<div
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded()"
>
  @if (minimizado) {
    <button
      irxBoton="principal"
      class="exceso-actividad-mini"
      cdkDragHandle
      (click)="onMiniClick()"
      tooltip="Descanso en curso"
    >
      <mat-icon>self_improvement</mat-icon>
      <span class="exceso-actividad-mini-time">{{ tiempoRestante }}</span>
      <mat-icon class="exceso-actividad-mini-expand">open_in_full</mat-icon>
    </button>
  } @else {
    <mat-card class="exceso-actividad">
      <!-- El encabezado es el asa del arrastre propio del banner (no usa el
           arrastre del card-header: la posición se recuerda por estado) -->
      <app-card-header
        cdkDragHandle
        class="exceso-actividad-header"
        [title]="fase === 'descanso' ? 'Descanso' : 'Tomate un descanso'"
        [icono]="fase === 'descanso' ? 'self_improvement' : 'coffee'"
        [draggable]="false"
        [botonAccion]="
          fase === 'descanso'
            ? { icon: 'remove', tooltip: 'Minimizar' }
            : undefined
        "
        (accion)="minimizar()"
      ></app-card-header>

      <mat-card-content class="card-content-crear">
        @if (fase === 'aviso') {
          <p class="exceso-actividad-mensaje">
            Registramos más de {{ data.minutosActividad | number: '1.0-0' }}
            minutos de actividad continua. Te recomendamos tomar un descanso.
          </p>
        } @else {
          <p class="exceso-actividad-mensaje">Descanso en curso. Volvé en:</p>
          <div class="exceso-actividad-countdown">{{ tiempoRestante }}</div>
          <mat-progress-bar mode="determinate" [value]="progreso" />
        }
      </mat-card-content>

      @if (fase === 'aviso') {
        <mat-card-actions class="actions-create">
          <button
            irxBoton="principal"
            type="button"
            (click)="aceptar()"
          >
            Entendido
          </button>
        </mat-card-actions>
      }
    </mat-card>
  }
</div>
